function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "twofactorauthentication-a",
  points: ".402 0 7.598 0 7.598 8 .402 8"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(12 12)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "twofactorauthentication-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#twofactorauthentication-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.0977,4.6338 L5.9997,3.9998 L7.0977,3.3658 C7.5767,3.0898 7.7407,2.4788 7.4637,1.9998 C7.1867,1.5208 6.5747,1.3578 6.0977,1.6338 L4.9997,2.2678 L4.9997,0.9998 C4.9997,0.4468 4.5527,-0.0002 3.9997,-0.0002 C3.4477,-0.0002 2.9997,0.4468 2.9997,0.9998 L2.9997,2.2678 L1.9027,1.6338 C1.4247,1.3578 0.8127,1.5208 0.5357,1.9998 C0.2597,2.4788 0.4237,3.0898 0.9027,3.3658 L1.9997,3.9998 L0.9027,4.6338 C0.4237,4.9098 0.2597,5.5218 0.5357,5.9998 C0.7217,6.3208 1.0577,6.4998 1.4037,6.4998 C1.5737,6.4998 1.7447,6.4568 1.9027,6.3658 L2.9997,5.7328 L2.9997,6.9998 C2.9997,7.5528 3.4477,7.9998 3.9997,7.9998 C4.5527,7.9998 4.9997,7.5528 4.9997,6.9998 L4.9997,5.7328 L6.0977,6.3658 C6.2547,6.4568 6.4267,6.4998 6.5967,6.4998 C6.9427,6.4998 7.2787,6.3208 7.4637,5.9998 C7.7407,5.5218 7.5767,4.9098 7.0977,4.6338",
  mask: "url(#twofactorauthentication-b)"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5 13C5 13.553 4.552 14 4 14 3.448 14 3 13.553 3 13 3 12.447 3.448 12 4 12 4.552 12 5 12.447 5 13M8 13C8 13.553 7.552 14 7 14 6.448 14 6 13.553 6 13 6 12.447 6.448 12 7 12 7.552 12 8 12.447 8 13M11 13C11 13.553 10.553 14 10 14 9.448 14 9 13.553 9 13 9 12.447 9.448 12 10 12 10.553 12 11 12.447 11 13"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4,5 C4,3.346 5.346,2 7,2 C8.654,2 10,3.346 10,5 L10,7 L4,7 L4,5 Z M12.003,7 L12,7 L12,5 C12,2.243 9.757,0 7,0 C4.243,0 2,2.243 2,5 L2,7 L1.997,7 C0.894,7 0,7.895 0,8.997 L0,16 C0,17.654 1.346,19 3,19 L10,19 C10.553,19 11,18.553 11,18 C11,17.447 10.553,17 10,17 L3,17 C2.449,17 2,16.552 2,16 L1.997,9.503 C1.997,9.226 2.222,9.001 2.499,9 L12,9 L12,10 C12,10.553 12.447,11 13,11 C13.553,11 14,10.553 14,10 L14,8.997 C14,7.895 13.105,7 12.003,7 L12.003,7 Z"
}));

var SvgTwoFactorAuthentication = function SvgTwoFactorAuthentication(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref, _ref2)
  );
};

export default SvgTwoFactorAuthentication;